import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import axiosClient from './axios-client';

export interface RefeicoesSummary {
  total: number;
  realizada: number;
  percentualRealizado: number;
}

export interface DadosEquilibria {
  peso: number;
  altura: number;
  riscoComorbidades: number;
  riscoCardioVascular: number;
  metaCopos: number;
  refeicoes: RefeicoesSummary;
}

export interface DadosMovia {
  classificacaoDor: number;
  melhoraPostura: number;
  riscoFisicoPsicossociais: number;
}

export interface DadosSaude {
  idPessoa: number;
  nomePessoa: string;
  data: string;
  equilibria: DadosEquilibria;
  movia: DadosMovia;
}

export interface ResumoSaudeResponse {
  status: number;
  message: string;
  data: DadosSaude | null;
  timestamp: string;
}

export interface DadosConsulta {
  idConsulta: number;
  data: string;
}

export interface DatasConsultasResponse {
  status: number;
  message: string;
  data: DadosConsulta[] | null;
  timestamp: string;
}

@Injectable({
  providedIn: 'root',
})
export class ResumoSaudeService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  async buscarResumoSaude(
    idPessoa: number,
    data: string, // formato: yyyy-MM-dd
  ): Promise<DadosSaude | null> {
    try {
      const response = await axiosClient.get<ResumoSaudeResponse>(
        `${this.apiUrl}/api/pessoa/${idPessoa}/saude`,
        {
          params: { data },
        },
      );

      return response.data?.data;
    } catch (error: any) {
      return null;
    }
  }

  async buscarDatasConsultas(idPessoa: number): Promise<Array<DadosConsulta>> {
    try {
      const res = await axiosClient.get(
        `${this.apiUrl}/api/pessoa/${idPessoa}/datas-consultas`,
      );

      const payload = res.data;
      const rawConsultas =
        payload?.data ??
        payload?.registroConsulta ??
        payload?.registro_consulta ??
        payload?.datasConsultas;

      if (!Array.isArray(rawConsultas)) {
        console.warn(
          '[ResumoSaudeService] Payload inesperado em /datas-consultas:',
          payload,
        );
        return [];
      }

      return rawConsultas
        .map((c: any) => ({
          idConsulta: Number(c?.idConsulta ?? c?.id ?? 0),
          data: String(c?.data ?? c?.dataConsulta ?? c?.dtConsulta ?? ''),
        }))
        .filter((c: DadosConsulta) => !!c.data);
    } catch (error: any) {
      console.error(
        '[ResumoSaudeService] Erro em /datas-consultas:',
        error?.response?.data ?? error,
      );
      return [];
    }
  }
}
